// extracted by mini-css-extract-plugin
export default {"wrapper":"TasksStarts_wrapper__FZhh6","starIcon":"TasksStarts_starIcon__-kUwL"};